const validate = values => {
    const errors = {};
    if (values.entityCodes && values.entityCodes.length <= 0) {
        errors.entityCodes = 'Please select merchant';
    }
    if (values.eventsList && values.eventsList.length <= 0) {
        errors.eventsList = 'Please select atleast one event';
    }
    return errors;
};

export default validate;
    